import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
// import axios from 'axios';

// Local Deps
import { Checkbox, Tag } from 'antd';
import get from 'lodash/get';

import startCase from 'lodash/startCase';
import { LinkContainer } from 'react-router-bootstrap';
// Local Deps
import { solicitationsShowRoute } from '../../../config/navigation/routes';
import './SolicitationsGrid.scss';
import Header from './subcomponents/Header';
import messages from '../../../config/messages';
import CustomCell from './subcomponents/CustomCell';
import logService from '../../../graphql/logging';

export default class SolicitationsGrid extends React.PureComponent {
  static propTypes = {
    solicitations: PropTypes.instanceOf(Array),
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onPageSizeChange: PropTypes.func.isRequired,
    onSortClick: PropTypes.func.isRequired,
    direction: PropTypes.string.isRequired,
    sortHeader: PropTypes.string.isRequired,
    folderized: PropTypes.instanceOf(Array).isRequired,
    flagged: PropTypes.func.isRequired,
    getSelectedSolicitations: PropTypes.func.isRequired,
    selectAll: PropTypes.number.isRequired,
    changeSelectAllValue: PropTypes.func.isRequired,
    rawSelected: PropTypes.any,
    organizationsCage: PropTypes.string.isRequired,
    userRole: PropTypes.string.isRequired,
    selectedTab: PropTypes.string.isRequired,
  };

  static defaultProps = {
    solicitations: [],
    rawSelected: {},
  };
  state = {
    flagged: {},
    data: this.props.solicitations,
  };

  addLogsOnToolingCagesClick = (tCage, tNiin, tAccessLevel) => {
    const postLogsBody = {

      level: 'info',
      message: `Clicked Tooling CAGE Column cage=${tCage} accessLevel=${tAccessLevel}`,
      className: 'pn-nffs-solicitation-search/src/components/grids/SolicitationsGrid/SolicitationsGrid.jsx',
      methodName: 'addLogsOnToolingCagesClick',

    };
    logService(postLogsBody)
      .then(() => {
        window.open(`/details?cage=${tCage}&niin=${tNiin}`, '_self');
        // window.location.href = `/details?cage=${tCage}&niin=${tNiin}`;
      }).catch((err) => {
        console.error({ msg: 'Error Unable to send logs to DB2!', postLogsBody }, err);
      });
  }

  // componentDidMount() { }

  toggleRow(id) {
    const newSelected = { ...this.props.rawSelected };
    if (newSelected[id]) {
      newSelected[id] = !this.props.rawSelected[id];
      if (!newSelected[id]) {
        delete newSelected[id];
      }
    } else {
      newSelected[id] = true;
    }

    const showButton = Object.keys(newSelected).length === 0 ? 0 : 2;
    this.props.changeSelectAllValue(newSelected, showButton);
    this.props.getSelectedSolicitations(Object.keys(newSelected));
  }

  toggleSelectAll() {
    const newSelected = {};

    if (this.props.selectAll === 0) {
      this.state.data.forEach(x => {
        newSelected[x.id] = true;
      });
    }
    const showButton = this.props.selectAll === 0 ? 1 : 0;
    this.props.changeSelectAllValue(newSelected, showButton);
    this.props.getSelectedSolicitations(Object.keys(newSelected));
  }

  render() {
    const { SolicitationsToolTips } = messages;
    const {
      solicitations,
      page,
      pageSize,
      pageCount,
      onPageChange,
      onPageSizeChange,
      onSortClick,
      folderized,
      flagged,
      organizationsCage,
      userRole,
      selectedTab,
    } = this.props;
    // const folderizedSolicitation = folderized.map(obj => obj.solicitationId);
    // const vals = Object.keys(folderized).map(key => folderized[key]);
    // const folderizedSolicitation = [].concat(...vals);

    // const test = [0, 1, 4, 2, 6, 0, 2, 6, 1, 0, 5, 0, 0, 6, 6, 6, 3, 3, 5, 1];
    let showFolders;
    let showStatus; //eslint-disable-line

    switch (selectedTab) {
      case 'open':
      case 'closed':
      case 'cancelled':
      case 'awarded':
        showStatus = false;
        showFolders = true;

        break;
      case 'tbq':
      case 'inprocess':
      case 'archived':
        showStatus = true;
        showFolders = false;
        break;

      default:
        showStatus = true;
        showFolders = true;
        break;
    }
    const columns = [
      {
        id: 'checkbox',
        accessor: '',
        Cell: cellProps => (
          <Checkbox
            checked={this.props.rawSelected[cellProps.original.id] === true}
            onChange={() => this.toggleRow(cellProps.original.id)}
          />
        ),
        Header: () => (
          <Checkbox
            checked={this.props.selectAll === 1}
            indeterminate={this.props.selectAll === 2}
            onChange={() => this.toggleSelectAll()}
          />
          // <Checkbox
          //   checked={this.props.selectAll === 1}
          //   ref={input => {
          //     if (input) {
          //       input.indeterminate = this.props.selectAll === 2;
          //     }
          //   }}
          //   onChange={() => this.toggleSelectAll()}
          // />
        ),
        sortable: false,
        width: 45,
      },
      {
        Header: () => <i className="fa fa-flag" />,
        accessor: 'isFlagged',
        Cell: cellProps => {
          const index = folderized.flagged.indexOf(cellProps.original.id);
          if (index >= 0) {
            return (
              <div
                role="button"
                tabIndex={0}
                onClick={() => {
                  flagged(cellProps.original.id);
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    flagged(cellProps.original.id);
                  }
                }}
              >
                <div id="line1" style={{ cursor: 'pointer' }}>
                  <i id="a" className="fa fa-flag " />
                  <i id="b" className="fa fa-flag" />
                </div>
              </div>
            );
          }
          if (this.state.flagged[cellProps.original.id] === true) {
            return (
              <div
                role="button"
                tabIndex={0}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  flagged(cellProps.original.id);
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    flagged(cellProps.original.id);
                  }
                }}
              >
                <i className="fa fa-flag" />
              </div>
            );
          }
          return (
            <div
              style={{ cursor: 'pointer' }}
              id="line1"
              role="button"
              tabIndex={0}
              onClick={() => {
                flagged(cellProps.original.id);
              }}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  flagged(cellProps.original.id);
                }
              }}
            >
              <i id="a" className="fa fa-flag-o" />
              <i id="b" className="fa fa-flag-checkered" />
            </div>
          );
        },
        width: 60,
      },


      {
        Header: <Header title="Date" tooltip={SolicitationsToolTips.date} />,
        accessor: 'issueDate',
        tooltip: 'Hello',
        width: 100,
        Cell: cellProps => <div className="date-column">{cellProps.value}</div>,
        headerClassName:
          this.props.sortHeader === 'Date'
            ? `nffs-column-header-${this.props.direction}`
            : `nffs-column-header`,
      },
      {
        Header: (
          <Header
            title="Solicitation #"
            tooltip={SolicitationsToolTips.solicitationNum}
          />
        ),
        accessor: 'id',
        width: 120,
        Cell: cellProps => (
          <LinkContainer
            to={`${solicitationsShowRoute.replace(
              ':solicitationId',
              cellProps.value,
            )}`}
            isActive={() => false}
            onClick={async () => {
              const postLogsBody = {
                level: '',
                message: '',
                className: '',
                methodName: '',
              };

              postLogsBody.level = 'info'; // can be info, warning or severe
              postLogsBody.message = `${cellProps.value},${organizationsCage}`;
              postLogsBody.className = 'SolicitationView';
              postLogsBody.methodName = 'solicitationDetailClick';

              try {
                await logService(postLogsBody)
              } catch (error) {
                console.error(
                  { msg: 'Error Unable to send logs to DB2!', postLogsBody },
                  error,
                );
              }
            }}
          >
            <div className="nf-cell--link">{cellProps.value}</div>
          </LinkContainer>
        ),
        headerClassName:
          this.props.sortHeader === 'Solicitation #'
            ? `nffs-column-header-${this.props.direction}`
            : `nffs-column-header`,
      },

      {
        Header: (
          <Header
            title="Close Date"
            tooltip={SolicitationsToolTips.closeDate}
          />
        ),
        accessor: 'returnDate',
        width: 100,
        Cell: cellProps => <div className="close-date-column">{cellProps.value}</div>,
        headerClassName:
          this.props.sortHeader === 'Close Date'
            ? `nffs-column-header-${this.props.direction}`
            : `nffs-column-header`,
      },
      {
        id: 'status',
        Header: (
          <Header
            title="Status"
            tooltip="Solicitation status as received from DIBBS"
          />
        ),
        show: showStatus, // boolean determined from selected Tab

        accessor: slct => get(slct, 'purchaseRequest.status', ''),
        width: 80,
        headerClassName:
          this.props.sortHeader === 'Status'
            ? `nffs-column-header-${this.props.direction}`
            : `nffs-column-header`,
      },

      {
        id: 'nsnPart',
        Header: <Header title="NSN" tooltip={SolicitationsToolTips.nsn} />,
        accessor: slct => get(slct, 'purchaseRequest.nsnPart', ''),
        width: 130,
        Cell: cellProps => <div className="nsn-column">{cellProps.value}</div>,
        headerClassName:
          this.props.sortHeader === 'NSN'
            ? `nffs-column-header-${this.props.direction}`
            : `nffs-column-header`,
      },

      {
        Header: (
          <Header
            title="Last Award Date"
            tooltip={SolicitationsToolTips.lastAward}
          />
        ),
        accessor: 'lastAward',
        width: 120,
        headerClassName:
          this.props.sortHeader === 'Last Award Date'
            ? `nffs-column-header-${this.props.direction}`
            : `nffs-column-header`,
      },
      {
        id: 'tooling cages',
        Header: (
          <Header
            title="Tooling CAGE"
            tooltip={SolicitationsToolTips.toolingCage}
          />
        ),
        width: 160,
        accessor: slct => get(slct, 'toolingCages', ''),
        Cell: cellProps => {
          if (!cellProps.value) {
            return '';
          }
          const tCages = cellProps.value.map(tc => {
            console.log(tc);
            if (userRole === 'SUPER_ADMIN') {
              return (
                <div>
                  <a
                    href
                    onClick={() => {
                      sessionStorage.removeItem("udHistory");
                      this.addLogsOnToolingCagesClick(
                        tc.cage,
                        cellProps.original.purchaseRequest.nsnPart.slice(-9),
                        tc.accessLevel === '0'
                          ? 'Private'
                          : tc.accessLevel === '1'
                            ? "Gov't Only"
                            : tc.accessLevel === '2'
                              ? 'Public'
                              : 'Private',
                      );
                    }}
                  >
                    <div className="nf-cell--link">
                      {tc.cage} /{' '}
                      {tc.accessLevel === '0'
                        ? 'Private'
                        : tc.accessLevel === '1'
                          ? "Gov't Only"
                          : tc.accessLevel === '2'
                            ? 'Public'
                            : 'Private'}{' '}
                    </div>
                  </a>
                </div>
              );
            }
            if (userRole === 'GOVERNMENT_USER' && tc.accessLevel >= '1') {
              return (
                <div>
                  <a
                    href
                    onClick={() => {
                      sessionStorage.removeItem("udHistory");
                      this.addLogsOnToolingCagesClick(
                        tc.cage,
                        cellProps.original.purchaseRequest.nsnPart.slice(-9),
                        tc.accessLevel === '0'
                          ? 'Private'
                          : tc.accessLevel === '1'
                            ? "Gov't Only"
                            : tc.accessLevel === '2'
                              ? 'Public'
                              : 'Private',
                      );
                    }}
                  >
                    <div className="nf-cell--link">
                      {tc.cage} /{' '}
                      {tc.accessLevel === '0'
                        ? 'Private'
                        : tc.accessLevel === '1'
                          ? "Gov't Only"
                          : tc.accessLevel === '2'
                            ? 'Public'
                            : 'Private'}{' '}
                    </div>
                  </a>
                </div>
              );
            }
            // if (userRole === "COMMON_ADMIN" && tc.cage.trim() === organizationsCage && tc.accessLevel !== 1) {
            if (
              (userRole === 'COMMON_ADMIN' &&
                (tc.cage.trim() === organizationsCage &&
                  tc.accessLevel !== '1')) ||
              (tc.cage.trim() !== organizationsCage && tc.accessLevel === '2')
            ) {
              return (
                <div>
                  <a
                    href
                    onClick={() => {
                      sessionStorage.removeItem("udHistory");
                      this.addLogsOnToolingCagesClick(
                        tc.cage,
                        cellProps.original.purchaseRequest.nsnPart.slice(-9),
                        tc.accessLevel === '0'
                          ? 'Private'
                          : tc.accessLevel === '1'
                            ? "Gov't Only"
                            : tc.accessLevel === '2'
                              ? 'Public'
                              : 'Private',
                      );
                    }}
                  >
                    <div className="nf-cell--link">
                      {tc.cage} /{' '}
                      {tc.accessLevel === '0'
                        ? 'Private'
                        : tc.accessLevel === '1'
                          ? "Gov't Only"
                          : tc.accessLevel === '2'
                            ? 'Public'
                            : 'Private'}{' '}
                    </div>
                  </a>
                </div>
              );
            }
            return '';
          });

          return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {tCages}
            </div>
          );
        },
      },
      {
        Header: (
          <Header
            title="Description"
            tooltip={SolicitationsToolTips.description}
          />
        ),
        accessor: slct => get(slct, 'purchaseRequest.nomenclature', ''),
        id: 'nomenclature',
        Cell: cellProps => (
          <div className="nf-cell--left-align">{cellProps.value}</div>
        ),
        minWidth: 200,
        headerClassName:
          this.props.sortHeader === 'Description'
            ? `nffs-column-header-${this.props.direction}`
            : `nffs-column-header`,
      },
      {
        id: 'quantity',
        Header: <Header title="Qty" tooltip={SolicitationsToolTips.qty} />,
        accessor: slct => get(slct, 'purchaseRequest.quantity', ''),
        width: 50,
        headerClassName:
          this.props.sortHeader === 'Qty'
            ? `nffs-column-header-${this.props.direction}`
            : `nffs-column-header`,
      },
      {
        id: 'um',
        Header: (
          <Header
            title="UI"
            tooltip="The unit of issue of the parts being requested"
          />
        ),
        accessor: slct => get(slct, 'um', ''),
        width: 60,
        headerClassName:
          this.props.sortHeader === 'UI'
            ? `nffs-column-header-${this.props.direction}`
            : `nffs-column-header`,
      },

      {
        Header: (
          <Header title="Est. Value" tooltip={SolicitationsToolTips.estValue} />
        ),
        accessor: 'value',

        width: 100,
        headerClassName:
          this.props.sortHeader === 'Est. Value'
            ? `nffs-column-header-${this.props.direction}`
            : `nffs-column-header`,
      },
      {
        Header: <Header title="SRVA" tooltip={SolicitationsToolTips.srva} />,
        accessor: 'srva',
        width: 60,
        headerClassName:
          this.props.sortHeader === 'SRVA'
            ? `nffs-column-header-${this.props.direction}`
            : `nffs-column-header`,
      },

      {
        Header: <Header title="Type" tooltip={SolicitationsToolTips.type} />,
        accessor: 'castingType',
        width: 140,
        headerClassName:
          this.props.sortHeader === 'Type'
            ? `nffs-column-header-${this.props.direction}`
            : `nffs-column-header`,
      },
      {
        Header: <Header title="AMC/AMSC" tooltip={SolicitationsToolTips.amc} />,
        accessor: 'amc',
        Cell: cellProps => (
          <CustomCell title={cellProps.value} tooltip={[cellProps.value]} />
        ),
        width: 100,
        headerClassName:
          this.props.sortHeader === 'AMC/AMSC'
            ? `nffs-column-header-${this.props.direction}`
            : `nffs-column-header`,
      },

      {
        Header: 'SetAside',
        accessor: 'setAside',
        width: 80,
      },

      {
        id: 'material',
        Header: (
          <Header
            title="Materials"
            tooltip="list of all available materials"
          />
        ),
        accessor: slct => get(slct, 'materialsMethods', ''),
        Cell: cellProps => {
          const arr = [];
          cellProps.value.forEach(element => {
            arr.push(
              <div>
                {element.material}
              </div>,
            );
          });
          return arr;
        },
        minWidth: 200,
        headerClassName:
          this.props.sortHeader === 'Material'
            ? `nffs-column-header-${this.props.direction}`
            : `nffs-column-header`,
      },


      {
        id: 'method',
        Header: (
          <Header
            title="Methods"
            tooltip="list of all available method"
          />
        ),
        accessor: slct => get(slct, 'materialsMethods', ''),
        Cell: cellProps => {
          const arr = [];
          cellProps.value.forEach(element => {
            arr.push(
              <div>
                {element.method}
              </div>,
            );
          });
          return arr;
        },
        minWidth: 200,
        headerClassName:
          this.props.sortHeader === 'Method'
            ? `nffs-column-header-${this.props.direction}`
            : `nffs-column-header`,
      },
      {
        Header: 'Folder',
        width: 100,
        show: showFolders,
        Cell: cellProps => {
          let text;
          Object.keys(folderized).forEach(item => {
            if (item === 'flagged') {
              return;
            }
            if (folderized[item].indexOf(cellProps.original.id) !== -1) {
              text = item;
            } // value
          });
          if (text) {
            switch (text) {
              case 'inprocess':
                text = 'In Process';
                break;
              case 'tbq':
                text = 'TBQ';
                break;

              default:
                text = startCase(text);
                break;
            }
            return <Tag color="">{text} </Tag>;
          }
          return '';
        },
      },
      {
        id: 'part number',
        Header: (
          <Header
            title="My Part Numbers"
            tooltip={SolicitationsToolTips.myPartNumber}
          />
        ),
        accessor: slct => get(slct, 'myPartNums', ''),
        Cell: cellProps => {
          if (!cellProps.value) {
            return '';
          }
          const test1 = cellProps.value.map(test => {
            if (test.cage && test.cage.trim() === organizationsCage) {
              return (
                <p style={{ marginBottom: '0px' }}>
                  {test.partNumber ? (
                    test.partNumber
                  ) : (
                    <i className="fa fa-wrench" aria-hidden="true" />
                  )}
                </p>
              );
            }
            return '';
          });

          return (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
              }}
            >
              {test1}
            </div>
          );
        },
        width: 120,
      },

    ];
    return (
      <div className="nf-solicitations-grid">
        <ReactTable
          data={solicitations}
          columns={columns}
          noDataText="No Data was found"
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          pages={pageCount}
          page={page}
          pageSize={pageSize}
          minRows={3}
          manual
          // // ---- TO DO ---
          // // Options should be true, Need to resize table based on input. Currently Retains 100vh(ish)
          showPageSizeOptions={false}
          getTheadThProps={(state, rowInfo, column) => ({
            onClick: () => {
              /* jshint expr: true */

              if (typeof column.Header === 'function') return;
              console.log(column.Header.props.title);

              if (
                column.Header.props.title === 'My Part Numbers' ||
                column.Header.props.title === 'Materials' ||
                column.Header.props.title === 'Methods' ||
                column.Header.props.title === 'Tooling CAGE'
              )
                return;

              let newSort;

              if (this.props.sortHeader === column.Header.props.title) {
                if (this.props.direction === 'ASC') {
                  newSort = 'DESC';
                } else if (this.props.direction === 'DESC') newSort = null;
                else newSort = 'ASC';
              } else {
                newSort = 'ASC';
              }
              onSortClick(column.Header.props.title, newSort);
            },
          })}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/SolicitationsGrid/SolicitationsGrid.jsx